export const PDV_CONTENT = {
  hero: {
    kicker: 'Para lojas e comércios com atendimento no balcão',
    title: 'Fechar o caixa e a venda não bater com o estoque não pode ser rotina.',
    subtitle:
      'Abra e feche o caixa com controle, registre sangria sem bagunça e emita a NFC-e na hora — tudo integrado automaticamente com estoque e financeiro.',
    cta: 'Quero organizar meu caixa',
    ctaMessage: 'Quero conhecer o sistema de PDV do 77Gestão',
    urgency: 'Todo dia sem controle de caixa é um dia a mais de diferença para explicar no fechamento.',
  },

  statsStrip: [
    { number: 'Atalhos', label: 'de teclado para vender mais rápido', icon: 'fa-solid fa-keyboard' },
    { number: 'Automática', label: 'emissão de NFC-e na venda', icon: 'fa-solid fa-receipt' },
    { number: 'Tempo real', label: 'baixa no estoque a cada venda', icon: 'fa-solid fa-boxes-stacked' },
  ],

  pain: {
    title: 'Reconhece esse dia a dia no caixa da sua loja?',
    intro:
      'Lojas com atendimento de balcão perdem tempo e dinheiro quando o caixa não tem controle e a venda não conversa com o estoque.',
    items: [
      { icon: 'fa-solid fa-cash-register', text: 'Caixa aberto e fechado sem registro — ninguém sabe quanto tinha no início do dia.' },
      { icon: 'fa-solid fa-money-bill-wave', text: 'Sangria feita informalmente, sem registro, difícil de explicar depois.' },
      { icon: 'fa-solid fa-hourglass-half', text: 'Fila no caixa porque cada venda demora demais para ser digitada.' },
      { icon: 'fa-solid fa-triangle-exclamation', text: 'Venda do dia não bate com o estoque — sobra ou falta sem explicação.' },
      { icon: 'fa-solid fa-file-invoice', text: 'Emissão de nota fiscal separada da venda, atrasando o cliente no balcão.' },
      { icon: 'fa-solid fa-chart-line', text: 'Financeiro só descobre o resultado do dia depois de alguém conferir tudo manualmente.' },
    ],
  },

  midCta: {
    text: 'E se cada venda no caixa já desse baixa no estoque, gerasse a nota fiscal e caísse no financeiro sozinha?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema de PDV do 77Gestão',
  },

  solution: {
    title: 'Frente de caixa rápida, com controle do início ao fim do dia',
    intro:
      'O PDV do 77Gestão foi feito para quem atende no balcão e precisa vender rápido sem perder o controle do caixa.',
    cards: [
      {
        icon: 'fa-solid fa-door-open',
        title: 'Abertura e fechamento de caixa',
        text: 'Registre o valor de abertura e feche o caixa no fim do turno com a conferência batendo com o sistema.',
      },
      {
        icon: 'fa-solid fa-hand-holding-dollar',
        title: 'Sangria controlada',
        text: 'Registre toda retirada de dinheiro do caixa, com valor, motivo e responsável — sem depender de anotação avulsa.',
      },
      {
        icon: 'fa-solid fa-keyboard',
        title: 'Atalhos de teclado',
        text: 'Venda mais rápido no balcão com atalhos pensados para agilizar cada etapa da venda, sem precisar do mouse.',
      },
      {
        icon: 'fa-solid fa-receipt',
        title: 'NFC-e emitida na hora',
        text: 'A nota fiscal de consumidor sai automaticamente ao fechar a venda, sem passos extras.',
      },
      {
        icon: 'fa-solid fa-boxes-stacked',
        title: 'Baixa automática no estoque',
        text: 'Cada venda no PDV atualiza o estoque na hora — sem depender de conferência manual no fim do dia.',
      },
      {
        icon: 'fa-solid fa-sack-dollar',
        title: 'Integração direta com o financeiro',
        text: 'O resultado do caixa já entra no financeiro automaticamente, sem lançamento manual depois.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando o caixa para de ser um ponto cego',
    intro:
      'Uma loja com atendimento de balcão fechava o caixa manualmente todos os dias e frequentemente encontrava diferença entre o dinheiro em caixa e o que constava nas vendas.',
    stats: [
      { number: '0', label: 'diferenças inexplicadas no fechamento' },
      { number: '100%', label: 'das vendas com NFC-e emitida na hora' },
      { number: '1 sistema', label: 'ligando caixa, estoque e financeiro' },
    ],
    paragraphs: [
      'Depois da implantação, cada abertura e fechamento de caixa passou a ser registrada no sistema, com sangria documentada e conferência automática no fim do turno.',
      'As vendas passaram a emitir a NFC-e na hora e a dar baixa automática no estoque, eliminando a divergência que antes só aparecia no fechamento manual.',
    ],
    highlight: 'Resultado: caixa batendo todos os dias e estoque sempre atualizado, sem conferência manual.',
    cta: 'Quero esse mesmo controle',
    ctaMessage: 'Vi o resultado e quero entender como organizar o caixa da minha loja no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a frente de caixa',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Você sabe exatamente quanto entrou, quanto saiu e o que está em caixa a qualquer momento.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Abertura, sangria e fechamento registrados — sem depender de anotação ou da memória de quem estava no caixa.',
      },
      {
        icon: 'fa-solid fa-bolt',
        title: 'Agilidade',
        text: 'Atalhos de teclado e emissão automática de nota deixam a fila no balcão andar mais rápido.',
      },
    ],
  },

  differentials: {
    title: 'Por que lojas escolhem o PDV do 77Gestão',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'PDV pensado para o ritmo do balcão, não adaptado de um sistema de escritório.' },
      { icon: 'fa-solid fa-link', text: 'Caixa integrado com estoque e financeiro — uma venda alimenta tudo, sem retrabalho.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada para sua equipe já vender no sistema com segurança.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado, também para quem opera o caixa.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'O PDV emite NFC-e automaticamente?',
        answer:
          'Sim. Ao fechar a venda no caixa, a NFC-e é emitida automaticamente, sem precisar de outro sistema.',
      },
      {
        question: 'Dá para registrar sangria e reforço de caixa?',
        answer:
          'Sim. Toda sangria fica registrada com valor, motivo e responsável, facilitando a conferência no fechamento.',
      },
      {
        question: 'O estoque atualiza sozinho a cada venda?',
        answer:
          'Sim. Cada venda no PDV dá baixa automática no estoque, então o saldo já reflete o que foi vendido no balcão.',
      },
      {
        question: 'Preciso de equipamento especial para usar o PDV?',
        answer:
          'O PDV funciona pelo navegador, sem necessidade de hardware específico além de uma impressora fiscal compatível, caso você já utilize uma.',
      },
      {
        question: 'Dá para ter mais de um caixa aberto ao mesmo tempo?',
        answer:
          'Sim. O sistema permite múltiplos caixas abertos simultaneamente, cada um com sua própria abertura, sangria e fechamento.',
      },
    ],
  },

  ctaFinal: {
    title: 'Seu caixa não precisa mais ser uma surpresa no fim do dia.',
    subtitle:
      'Agende uma demonstração e veja como abrir, vender e fechar o caixa com controle total, sem depender de conferência manual.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema de PDV do 77Gestão',
  },

  seo: {
    title: 'Sistema de PDV e Frente de Caixa para Lojas | 77Gestão',
    description:
      'Sistema de PDV completo: abertura e fechamento de caixa, sangria controlada, atalhos de teclado e NFC-e automática. Agende uma demonstração grátis.',
  },
};
